import {
  /* creatMsg */
  getUserList,
  sendMsg,
  createDraftMsg,
  getDraftMsgInfo,
  getMsgInfo,
  /* receiptMsg */
  getReceiptMsgList,
  getReceiptTopicCount,
  getReceiptMsgCount,
  getReceiptMsgUnreadCount,
  getReceiptMsgListSearch,
  getReceiptMsgListSearchCount,
  getReceiptMsgDetailList,
  replyReceiptMsg,
  createReceiptDraftMsg,
  /* sendMsg */
  getSendMsgList,
  getSendMsgCount,
  getSendMsgListSearch,
  getSendMsgListSearchCount,
  getSendMsgDetailList,
  replySendMsg,
  createSendDraftMsg,
  /* draftsMsg */
  getDraftsList,
  getDraftsCount,
  deleteDrafts,
  /* systemMsg */
  getSystemMsgList,
  getSystemMsgCount,
  getRead,
  /* searchMsg */
  getMsgList,
  getMsgCount
} from 'api/message'
const message = {
  state: {
    // userList: [],
    // msgInfo: []
  },
  mutations: {
    // SET_USERLIST (state, data) {
    //   state.userList = data.userList
    // },
    // SET_MSGINFO (state, data) {
    //   state.msgInfo = data
    // }
  },
  actions: {
    /* creatMsg */
    getUserList ({commit}, params) {
      return new Promise((resolve, reject) => {
        getUserList(params).then((res) => {
          commit('SET_USERLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    sendMsg ({commit}, params) {
      return new Promise((resolve, reject) => {
        sendMsg(params).then((res) => {
          console.log(res)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    createDraftMsg ({commit}, params) {
      return new Promise((resolve, reject) => {
        createDraftMsg(params).then((res) => {
          console.log(res)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getDraftMsgInfo ({commit}, params) {
      return new Promise((resolve, reject) => {
        getDraftMsgInfo(params).then((res) => {
          // commit('SET_MSGINFO', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getMsgInfo ({commit}, params) {
      return new Promise((resolve, reject) => {
        getMsgInfo(params).then((res) => {
          // commit('SET_MSGINFO', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    /* receiptMsg */
    getReceiptMsgList ({commit}, params) {
      return new Promise((resolve, reject) => {
        getReceiptMsgList(params).then((res) => {
          // commit('SET_MSGLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReceiptTopicCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getReceiptTopicCount(params).then((res) => {
          // commit('SET_TOPICCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReceiptMsgCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getReceiptMsgCount(params).then((res) => {
          // commit('SET_MSGCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReceiptMsgUnreadCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getReceiptMsgUnreadCount(params).then((res) => {
          // commit('SET_MSGUNREADCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReceiptMsgListSearch ({commit}, params) {
      return new Promise((resolve, reject) => {
        getReceiptMsgListSearch(params).then((res) => {
          // commit('SET_SEARCHLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReceiptMsgListSearchCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getReceiptMsgListSearchCount(params).then((res) => {
          // commit('SET_SEARCHLISTCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReceiptMsgDetailList ({commit}, params) {
      return new Promise((resolve, reject) => {
        getReceiptMsgDetailList(params).then((res) => {
          // commit('SET_MSGDETAILLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    replyReceiptMsg ({commit}, params) {
      return new Promise((resolve, reject) => {
        replyReceiptMsg(params).then((res) => {
          // console.log(res)
          resolve()
        })
      }).catch(error => {
        console.log(error)
      })
    },
    createReceiptDraftMsg ({commit}, params) {
      return new Promise((resolve, reject) => {
        createReceiptDraftMsg(params).then((res) => {
          // console.log(res)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    /* sendMsg */
    getSendMsgList ({commit}, params) {
      return new Promise((resolve, reject) => {
        getSendMsgList(params).then((res) => {
          // commit('SET_MSGLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getSendMsgCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getSendMsgCount(params).then((res) => {
          // commit('SET_MSGCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getSendMsgListSearch ({commit}, params) {
      return new Promise((resolve, reject) => {
        getSendMsgListSearch(params).then((res) => {
          // commit('SET_SEARCHLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getSendMsgListSearchCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getSendMsgListSearchCount(params).then((res) => {
          // commit('SET_SEARCHLISTCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getSendMsgDetailList ({commit}, params) {
      return new Promise((resolve, reject) => {
        getSendMsgDetailList(params).then((res) => {
          // commit('SET_MSGDETAILLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    replySendMsg ({commit}, params) {
      return new Promise((resolve, reject) => {
        replySendMsg(params).then((res) => {
          console.log(res)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    createSendDraftMsg ({commit}, params) {
      return new Promise((resolve, reject) => {
        createSendDraftMsg(params).then((res) => {
          console.log(res)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    /* draftsMsg */
    getDraftsList ({commit}, params) {
      return new Promise((resolve, reject) => {
        getDraftsList(params).then((res) => {
          // commit('SET_MSGLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getDraftsCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getDraftsCount(params).then((res) => {
          // commit('SET_MSGCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    deleteDrafts ({commit}, params) {
      return new Promise((resolve, reject) => {
        deleteDrafts(params).then((res) => {
          // commit('SET_MSGCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    /* systemMsg */
    getSystemMsgList ({commit}, params) {
      return new Promise((resolve, reject) => {
        getSystemMsgList(params).then((res) => {
          // commit('SET_MSGLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getSystemMsgCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getSystemMsgCount(params).then((res) => {
          // commit('SET_MSGCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getRead ({commit}, params) {
      return new Promise((resolve, reject) => {
        getRead(params).then((res) => {
          // commit('SET_MSGDETAIL', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    /* searchMsg */
    getMsgList ({commit}, params) {
      return new Promise((resolve, reject) => {
        getMsgList(params).then((res) => {
          // commit('SET_MSGLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getMsgCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getMsgCount(params).then((res) => {
          // commit('SET_MSGCOUNT', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
export default message



// WEBPACK FOOTER //
// ./src/store/modules/admin/message.js